<template>
  <div class="sign-container">
    <div class="left-container">
      <!-- 查询条件 -->
      <queryCondition
        style="min-height:212px;"
        ref="queryForm"
        :More="isHaseMore"
        :formConfig="queryCondditionDatas"
      ></queryCondition>
      <!-- 按钮列表 -->
      <div class="glo_btnList" ref="btnList" style="margin-left:0px;">
        <queryBtns style="margin-left:0;"
          :MoreConditions="MoreConditions"
          @clerBtns="clerBtns"
          @queryBtn_ok="queryBtn_ok"
          @moreParam="moreParam"
          :showMoreBtns="false"
          :refreshWhileClear="true"
        ></queryBtns>
      </div>
      <!-- 表格 -->
      <mytable
        :tableHeigth="tableHeigth"
        :tableData="tableData_1"
        :myTableHeard="myTableHeard"
        :isShowOperate="false"
        :isShowMoreOperate="false"
        :Operatewidth="0"
        ref="mytable"
        :showFilter="false"
        rowStyleKey="isException"
      >
      </mytable>
      <paging
        ref="pags"
        :pageNum="pageStart"
        :total="pageCount"
        :size="pageTotal"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></paging>
    </div>
    <div style="height:100%;" class="mid-container-parent">
      <div class="mid-container" style="margin-top:282px;">
        <span style="font-size: 15px;color:#ef7c0a;">定位运单号</span>
        <el-input
          v-model="waybillQuickIndex"
          placeholder="请输入"
          @input="changeQuickIndex"
          @keyup.enter.native="justSelectThose()"
          class="quick-index-input"
        ></el-input>
        <el-button icon="el-icon-d-arrow-right" @click="allToRight" class="first-ontton"></el-button>
        <el-button icon="el-icon-arrow-right" @click="toRight" ></el-button>
        <el-button icon="el-icon-arrow-left" @click="toLeft" ></el-button>
        <el-button icon="el-icon-d-arrow-left" @click="allToLeft"></el-button>
      </div>
    </div>
    <div class="right-container">
      <waybill-sign
        :data="tranferDatas"
        ref="signForm"
        @removeOne="removeOne"
        @signSuccess="signSuccess"
        @clear="clear"
      ></waybill-sign>
    </div>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import mytable from "@/components/table/VrTable.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import paging from "@/components/pagings.vue"; //分页组件
import WaybillSign from "./WaybillSigne.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    mytable,
    queryCondition,
    queryBtns,
    paging,
    WaybillSign,
  },
  props: {
    dispatchId: {},
  },
  data() {
    return {
      pageGroupName: "admin_waybill_sign_list_v5", //  页面标识
      reportFiledsNumber: "admin_waybill_sign_list_v5", // 动态 条件、表头
      tranferDatas: [],
      conditions: {
        //qianShou:0,
        dispatchId: this.dispatchId,
      },
      tableData_1: [],
      waybillQuickIndex: "",
      temp: [],
      a: 1,
      isHaseMore: true,
      timer: null,
    };
  },
  watch: {
    dispatchId: {
      handler(val) {
        this.getOrders();
      },
    },
  },
  methods: {
    clear(){
      this.tranferDatas = []
    },
    changeQuickIndex() {
      // if(true){
      //   this.tableData = this.temp;
      //   this.calcSelectableTableData();
      //   return
      // }
      if (!this.waybillQuickIndex) {
          this.tableData = this.temp;
          this.calcSelectableTableData();
          return;
        }
        this.tableData = this.temp.filter((item) =>
          item.waybillNumber.includes(this.waybillQuickIndex)
        );
        this.calcSelectableTableData();
    },
    doRemote(){
      if(!this.waybillQuickIndex){
        this.$message.warning("请输入运单号");
        return;
      }



      if(this.timer){
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(async () => {
          const res = await this.getDataOnly({
            waybillNumberNoLike:this.waybillQuickIndex,
            startCreateTime:'',
            endCreateTime:''
          });
          if(!res.data || res.data.length == 0){
            this.$message.warning("找不到运单")
          }else{
            const ids = this.tranferDatas.map((item) => item.waybillSplitId);
            console.log(res.data)
            for (let item of res.data) {
              if (!ids.includes(item.waybillSplitId)) {
                this.tranferDatas.push({
                  ...item,
                });
                item.selectable = false;
                //this.mytableRefresh(item);
              }
            }
          }
          this.waybillQuickIndex = ""
        }, 600);
    },
    justSelectThose() {
      // 这个版本改为直接插，不需要找本地
      if (this.tableData_1.length == 0) {
        this.doRemote()
        return;
      }
      this.changeQuickIndex()
      if (this.tableData_1.length == 0) {
        this.doRemote()
        return;
      }
      const ids = this.tranferDatas.map((item) => item.waybillSplitId);
      for (let item of this.tableData_1) {
        if (!ids.includes(item.waybillSplitId)) {
          this.tranferDatas.push({
            ...item,
          });
          item.selectable = false;
          //this.mytableRefresh(item);
        }
      }
      this.calcSelectableTableData();
    },
    ready() {
      this.getOrders();
    },
    fetched() {
      this.temp = this.tableData;
      this.changeQuickIndex();
    },
    async getOrders() {
      if (this.dispatchId) {
        this.setCondition("startCreateTime");
        this.setCondition("endCreateTime");
        await this.getData();
        this.allToRight();
      }
    },
    toRight() {
      const ids = this.tranferDatas.map((item) => item.waybillSplitId);
      for (let item of this.selectTableData) {
        if (!ids.includes(item.waybillSplitId)) {
          this.tranferDatas.push({
            ...item,
          });
          item.selectable = false;
          //this.mytableRefresh(item);
        }
      }
      this.calcSelectableTableData();
    },
    toLeft() {
      const rightDatas = this.$refs.signForm.selectTableData;
      const waybillIds = this.tableData.map((item) => item.waybillSplitId);
      // 需要反过来删除
      for (let item of rightDatas) {
        const ids = this.tranferDatas.map((item) => item.waybillSplitId);
        const pos = ids.indexOf(item.waybillSplitId);
        this.tranferDatas.splice(pos, 1);
        const pos1 = waybillIds.indexOf(item.waybillSplitId);
        if (this.tableData[pos1]) {
          this.tableData[pos1].selectable = true;
          //this.mytableRefresh(this.tableData[pos1]);
        }
      }
      this.calcSelectableTableData();
    },
    allToRight() {
      if(this.tableData.length > 100){
        this.$message.warning("数量超过100,请分批签收");
        return
      }
      const ids = this.tranferDatas.map((item) => item.waybillSplitId);
      this.$refs.mytable.selectAll();
      setTimeout(() => {
        this.$nextTick(() => {
          for (let item of this.tableData) {
            if (!ids.includes(item.waybillSplitId)) {
              this.tranferDatas.push({
                ...item,
              });
              item.selectable = false;
              //this.mytableRefresh(item);
            }
          }
          this.calcSelectableTableData();
        });
      }, 400);
    },
    allToLeft() {
      const rightDatas = this.tranferDatas;
      const waybillIds = this.tableData.map((item) => item.waybillSplitId);
      const ids = this.tranferDatas.map((item) => item.waybillSplitId);
      for (let item of rightDatas) {
        const pos = ids.indexOf(item.waybillSplitId);
        const pos1 = waybillIds.indexOf(item.waybillSplitId);
        if (this.tableData[pos1]) {
          this.tableData[pos1].selectable = true;
          //this.mytableRefresh(this.tableData[pos1]);
        }
      }
      this.tranferDatas = [];
      this.calcSelectableTableData();
    },
    removeOne(row) {
      const ids = this.tranferDatas.map((item) => item.waybillSplitId);
      const waybillIds = this.tableData.map((item) => item.waybillSplitId);
      const pos = ids.indexOf(row.waybillSplitId);
      this.tranferDatas.splice(pos, 1);
      const pos1 = waybillIds.indexOf(row.waybillSplitId);
      if (this.tableData[pos1]) {
        this.tableData[pos1].selectable = true;
        //this.mytableRefresh(this.tableData[pos1]);
      }
      this.calcSelectableTableData();
    },
    signSuccess() {
      this.tranferDatas = [];
    },
    calcSelectableTableData() {
      const ids = this.tranferDatas.map((item) => item.waybillSplitId);
      for (let item of this.tableData) {
        if (ids.includes(item.waybillSplitId)) {
          item.selectable = false;
          //this.mytableRefresh(item);
        }
      }
      this.tableData_1 = this.tableData.filter(
        (item) => item.selectable != false
      );
    },
    mytableRefresh(row) {
      this.$refs.mytable.resetCheckbox(row);
    },
  },
};
</script>

<style scoped lang="less">
.sign-container {
  height: calc(100vh - 80px);
  display: flex;
  .left-container {
    width: 550px;
    overflow: hidden;
    border-right:1px solid rgba(0, 0, 0, 0.1);
  }
  .mid-container-parent{
    
  }
  .mid-container {
    width: 100px;
    display: flex;
    flex-flow: column;
    align-items: center;
    align-self: center;
    justify-content: center;
    .el-button {
      margin: 0;
      font-size: 30px;
      border: none;
      padding: 0;
      padding-top: 3px;
      padding-bottom: 3px;
      margin-top: 2px;
      width: 90%;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
  .right-container {
    flex: 1;
    overflow: hidden;
    min-width: 550px;
    border-left:1px solid rgba(0, 0, 0, 0.1);
  }
}
.quick-index-input{
  margin-top:5px;
  width: 90%;
  /deep/ .el-input__inner{
    //border-radius: 0;
    //border-left: none;
    //border-right:none;
  }
}
</style>